import { Component, EventEmitter, Output } from '@angular/core';
import { TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';

@Component({
	selector: 'mb-explore-card',
	templateUrl: './explore-card.component.html',
	styleUrls: ['./explore-card.component.scss']
})
export class ExploreCardComponent {

	@InjectConfig(ModelsExperienceConfigKey.EXPLORE_CARD_FILTERS) public readonly exploreCardFilters: Array<string> = [];
	@Output() public onExploreCardChange: EventEmitter<string> = new EventEmitter<string>();
	public selectedCardId: string = '';

	constructor(private tealiumAnalyticsService: TealiumAnalyticsService) { }

	public onExploreCardSelect(card: string): void {
		this.selectedCardId = card;
		const eventName = TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME + ':' + TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_HOME_PAGE + `:explore card:${this.selectedCardId}`;
		this.tealiumAnalyticsService.trackEventTealium(new TealiumAnalyticsEvent(eventName, {
			toolName: TealiumConstants.TOOL_NAMES.MODELS_EXPERIENCE
		}));
		this.onExploreCardChange.emit(card);
	}

}
